module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certificate"
  }, [_c('div', {
    staticStyle: {
      "min-height": "calc(100% - 220px)",
      "box-sizing": "border-box"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "commonW"
  }, [_c('div', {
    staticClass: "step01"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("在线获取线下平台证书")]), _vm._v(" "), _c('el-form', {
    ref: "searchForm",
    attrs: {
      "model": _vm.searchForm,
      "rules": _vm.searchRules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "projectId"
    }
  }, [_c('el-input', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "name": "textfield",
      "placeholder": "请输入项目编号",
      "maxlength": 8
    },
    model: {
      value: (_vm.searchForm.projectId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "projectId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.projectId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question",
    on: {
      "click": function($event) {
        return _vm.toQuestions('1')
      }
    }
  }, [_vm._v("如何查看找到项目编号？")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "securityCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "name": "textfield",
      "placeholder": "请输入安全码",
      "maxlength": 8
    },
    model: {
      value: (_vm.searchForm.securityCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "securityCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.securityCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question",
    on: {
      "click": function($event) {
        return _vm.toQuestions('1')
      }
    }
  }, [_vm._v("如何查看找到安全码？")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "validCode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "验证码",
      "maxlength": 4
    },
    model: {
      value: (_vm.searchForm.validCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "validCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.validCode"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "code",
    staticStyle: {
      "font-size": "20px",
      "margin-left": "30px"
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('em', {
    staticClass: "code-data",
    on: {
      "click": _vm.getValidCode
    }
  }, [_vm._v(_vm._s(_vm.codedata))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "680px",
      "text-align": "center",
      "margin-top": "80px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searching
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchSubmit($event)
      }
    }
  }, [_vm._v("查询\r\n        ")])], 1)], 1)], 1)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assessTit"
  }, [_c('div', {
    staticClass: "commonW",
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/wangLG.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../assets/tel.png")
    }
  })]), _vm._v("  400-777-5999")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer clear-fix",
    staticStyle: {
      "min-width": "1100px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "1100px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/about.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业介绍")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/qiyewenhua.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业文化")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/zizhirongyu.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("资质荣誉")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/hezuohuoban73.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/pinpaiziyuan.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("品牌资源")])])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor1"
  }), _vm._v(" "), _c('div', {
    staticClass: "concatUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', [_vm._v("总　　机　0755-86675999 ")]), _vm._v(" "), _c('div', [_vm._v("销售邮箱　shangwu@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("售后邮箱　fw@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("总部地址　深圳市南山区学苑大道1001号南山智园C1栋12楼")]), _vm._v(" "), _c('div', [_vm._v("邮　　编　518055   ")])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor2"
  }), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_c('div', [_vm._v("Copyright © 1997-2020 版权所有:深圳市旺龙智能科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("粤ICP备18085992号")]), _vm._v(" "), _c('div', [_vm._v("旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0111b6eb"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 784
// module chunks = 1